import script from "./join-us-submissions.vue?vue&type=script&lang=ts&setup=true"
export * from "./join-us-submissions.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__